import { render, staticRenderFns } from "./ButtonShareLink.vue?vue&type=template&id=3aefc70f&lang=pug"
import script from "./ButtonShareLink.vue?vue&type=script&lang=ts"
export * from "./ButtonShareLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports